import { Icon } from '@types';

export const Help = ({ customStyles, handleClick }: Icon) => (
	<svg
		className={customStyles}
		onClick={handleClick}
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 76.18 67.65"
	>
		<defs>
			<style>
				{
					'.cls-help,.cls-help-2{fill:#fff;}.cls-help-2,.cls-help-3{stroke:#2e2d2c;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-help-3{fill:none;}'
				}
			</style>
		</defs>
		<path
			className="cls-help-3"
			d="M36.3,22.82h35.21c2.02,0,3.67,1.65,3.67,3.67v25.4c0,2.02-1.65,3.67-3.67,3.67h-6.15v9.68c0,1.27-1.53,1.9-2.43,1l-9.42-10.68h-17.22c-2.02,0-3.67-1.65-3.67-3.67V26.48c0-2.02,1.65-3.67,3.67-3.67Z"
		/>
		<g>
			<g>
				<g>
					<path
						className="cls-help"
						d="M14.6,48.87c-1.71,0-3.11-1.39-3.11-3.1v-8H7.02c-2.95,0-5.34-2.4-5.34-5.34V7.02C1.68,4.07,4.07,1.68,7.02,1.68H42.23c2.95,0,5.34,2.4,5.34,5.34v25.4c0,2.95-2.4,5.34-5.34,5.34H25.77l-8.93,10.12c-.66,.66-1.43,.99-2.25,.99Z"
					/>
					<path
						className="cls-help"
						d="M42.23,3.35c2.02,0,3.67,1.65,3.67,3.67v25.4c0,2.02-1.65,3.67-3.67,3.67H25.01l-9.42,10.68c-.29,.29-.65,.42-.99,.42-.73,0-1.43-.57-1.43-1.42v-9.68H7.02c-2.02,0-3.67-1.65-3.67-3.67V7.02c0-2.02,1.65-3.67,3.67-3.67H42.23m0-3.35H7.02C3.15,0,0,3.15,0,7.02v25.4c0,3.87,3.15,7.02,7.02,7.02h2.79v6.33c0,2.63,2.15,4.78,4.78,4.78,1.27,0,2.46-.5,3.37-1.4,.05-.05,.1-.1,.14-.15l8.42-9.55h15.7c3.87,0,7.02-3.15,7.02-7.02V7.02c0-3.87-3.15-7.02-7.02-7.02h0Z"
					/>
				</g>
				<path
					className="cls-help-2"
					d="M42.23,3.35H7.02c-2.02,0-3.67,1.65-3.67,3.67v25.4c0,2.02,1.65,3.67,3.67,3.67h6.15v9.68c0,1.27,1.53,1.9,2.43,1l9.42-10.68h17.22c2.02,0,3.67-1.65,3.67-3.67V7.02c0-2.02-1.65-3.67-3.67-3.67Z"
				/>
			</g>
			<g>
				<path
					className="cls-help-3"
					d="M24.63,24.9v-.7c0-2.23,1.23-3.5,2.56-4.84,1.31-1.32,2.52-2.57,2.52-4.74,0-2.8-2.28-5.08-5.08-5.08s-5.08,2.28-5.08,5.08"
				/>
				<line className="cls-help-3" x1={24.63} y1={29.37} x2={24.63} y2={29.37} />
			</g>
		</g>
		<g>
			<line className="cls-help-2" x1={53.91} y1={48.81} x2={53.91} y2={48.81} />
			<line className="cls-help-2" x1={40.5} y1={48.81} x2={40.5} y2={48.81} />
			<line className="cls-help-2" x1={44.97} y1={48.81} x2={44.97} y2={48.81} />
			<line className="cls-help-2" x1={49.44} y1={48.81} x2={49.44} y2={48.81} />
			<line className="cls-help-2" x1={53.91} y1={44.34} x2={53.91} y2={28.98} />
		</g>
	</svg>
);
